import { type ReactNode } from "react";

export type KpiProps = {
  label: string;
  value: ReactNode;
  /** Optional delta, rendered as a small chip below the value. */
  delta?: { value: string; tone?: "good" | "bad" | "neutral" };
  hint?: string;
};

const DELTA_TONE = {
  good: "text-good bg-good/10 border-good/20",
  bad: "text-bad bg-bad/10 border-bad/20",
  neutral: "text-ink-soft bg-line/40 border-line",
} as const;

export function Kpi({ label, value, delta, hint }: KpiProps) {
  return (
    <div className="rounded-xl border border-line bg-canvas-2 p-5">
      <div className="text-xs uppercase tracking-wider text-ink-soft">{label}</div>
      <div className="mt-2 font-display text-3xl leading-tight text-ink">
        {value}
      </div>
      {delta && (
        <span
          className={`mt-3 inline-flex items-center text-xs px-2 py-1 rounded-md border ${DELTA_TONE[delta.tone ?? "neutral"]}`}
        >
          {delta.value}
        </span>
      )}
      {hint && <p className="mt-2 text-xs text-ink-soft">{hint}</p>}
    </div>
  );
}

export function KpiRow({ children }: { children: ReactNode }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {children}
    </div>
  );
}
